import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

type Operation = 'create' | 'update' | 'delete';
export type Status = 'in_progress' | 'failed' | 'scheduled' | 'done' | undefined;

export type NotificationsState = {
    scheduledDeployment: {
        operation: Operation;
        status: Status;
    };
};

export type NotificationsActions = {
    setOperation: (operation: Operation) => void;
    setStatus: (status: Status) => void;
};

export const useNotificationsStore = create(
    immer<NotificationsState & NotificationsActions>((set) => ({
        scheduledDeployment: {
            operation: 'create',
            status: undefined
        },
        setOperation: (operation) => {
            set((state) => {
                state.scheduledDeployment.operation = operation;
            });
        },
        setStatus: (status) => {
            set((state) => {
                state.scheduledDeployment.status = status;
            });
        }
    }))
);
